const COOP_PROBE_DELAY_MS = 1000
const CHECK_INTERVAL_MS = 500

/** Watches an OAuth popup for one dismissal. Why not a bare `popup.closed`: docs/memory/oauth-popup-cancel-and-supersede.md */
export const watchPopupClosed = (popup: Window, onClosed: () => void) => {
  let timer: ReturnType<typeof setTimeout> | null = null
  let interval: ReturnType<typeof setInterval> | null = null

  const stop = () => {
    if (timer) clearTimeout(timer)
    if (interval) clearInterval(interval)
    timer = null
    interval = null
  }

  const isClosed = () => {
    try {
      return popup.closed
    } catch {
      return false
    }
  }

  timer = setTimeout(() => {
    if (isClosed()) {
      stop()
      return
    }
    interval = setInterval(() => {
      if (!isClosed()) return
      stop()
      onClosed()
    }, CHECK_INTERVAL_MS)
  }, COOP_PROBE_DELAY_MS)

  return stop
}
